import {Component, Vue} from 'vue-facing-decorator';

@Component({})
export default class PartnerBadge extends Vue {
}
